import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TrendingDownIcon(props: IconProps) {
    return <Icon {...props} iconKey={"trending_down"}/>
}
